<template>
    <main>
        <Head>
            <link
                rel="icon"
                href="/images/icon.jpeg"
                type="image/gif"
                sizes="16x16"
            />
            <title>Sultan Fatah - Pendaftaran Online</title>
        </Head>
        <div
            class="text-md flex flex-wrap items-center justify-center gap-3 bg-[#fde9b1] px-6 py-4 font-medium"
        >
            <marquee>📪 Sahabat Menuju Sehat - {{ informasi }}</marquee>
        </div>
        <div class="flex justify-end">
            <Link class="mt-5 font-poppins font-light mr-5 hover:underline text-sm mb-10" href="/auth/login">
                👨‍💻 Menuju halaman login Manajemen ↗
            </Link>
        </div>
        <div class="container md:px-28">
            <slot />
            <div v-if="$page.url != '/'" class="w-full md:w-1/2 mx-auto">
                <hr class="mt-5" />
                <Link
                    @click="back"
                    class="btn-red rounded-3xl mt-2 text-white m-auto w-32 h-14"
                >
                    KEMBALI
                </Link>
            </div>
        </div>
    </main>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import { Head } from "@inertiajs/inertia-vue3";
import RandomShape from "./RandomShape.vue";
import Contact from "./Contact.vue";

export default {
    components: {
        RandomShape,
        Head,
        Contact,
        Link,
    },
    props: {
        informasi: String,
    },
    methods: {
        back() {
            window.history.back();
        },
    },
};
</script>
